export const validation = {
  blockTitleMaxChar: 200,
  blocks: {
    min: 1,
    max: 3
  }
}
